import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const legGoodFields: FieldInterface[] = [
  {
    key: 'amount',
    originKey: 'amount',
    type: FIELD_TYPES.number,
  },
]

const legGoodRelations: RelationInterface[] = []

export { legGoodFields, legGoodRelations }
